import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environment } from '../../../environments/environment';
import { NotificationDetailsModel } from "../models/notification-details.model";
import { NotificationListModel } from "../models/notification-list.model";
import { NotificationsCountModel } from "../models/notifications-count.model";
import { HttpCustomHeaderEnum } from "../../shared/enums/http-custom-header.enum";

@Injectable({
    providedIn: 'root'
})

export class NotificationsService {

    constructor(private httpClient: HttpClient) { }

    public getNotificationById(id: string): Observable<NotificationDetailsModel> {
        return this.httpClient.get<NotificationDetailsModel>(`${environment.api}/notifications/${id}`);
    }

    public getNotifications(skip: number, take: number): Observable<NotificationListModel[]> {
        return this.httpClient.get<NotificationListModel[]>(`${environment.api}/notifications?skip=${skip}&take=${take}`);
    }

    public getNotificationsCount(): Observable<NotificationsCountModel> {
        const headers = new HttpHeaders({ [HttpCustomHeaderEnum.Skip_Error_Handling]: 'true' });
        return this.httpClient.get<NotificationsCountModel>(`${environment.api}/notifications/count`, { headers });
    }

    public markNotificationsAsRead(): Observable<void> {
        const headers = new HttpHeaders({ [HttpCustomHeaderEnum.Skip_Error_Handling]: 'true' });
        return this.httpClient.put<void>(`${environment.api}/notifications/markAsRead`, { headers });
    }
}
